export default function(data) {
  dataLayerPush(data);
}

export function trackServerEvent() {
  const eventJson = document.body.getAttribute('data-track-server-event');
  if (!eventJson) return;
  try {
    const eventData = JSON.parse(eventJson);
    if (eventData instanceof Array) {
      eventData.forEach(data => dataLayerPush(data));
    } else {
      dataLayerPush(eventData);
    }
  } catch (e) {
    if (window.ENV === 'development') {
      throw e;
    }
  }
}

function dataLayerPush(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);

  if (window.ENV === 'development') {
    console.log('window.dataLayer.push', data); // eslint-disable-line no-console
  }
}
